"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _email = require("@/api/email");
var _leads = require("@/api/leads");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = {};
    this.loading = false;
  }
  created() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchData(Number(id));
    }
  }
  extractEmail(raw) {
    if (!raw) return '';
    const match = raw.match(/<(.+?)>/);
    if (match) return match[1];
    return raw.split(',')[0].trim();
  }
  async addToLead() {
    const row = this.formData;
    if (!row || !row.id) {
      this.$message.error('Email not loaded yet');
      return;
    }
    try {
      const email = this.extractEmail(row.from);
      if (!email) {
        this.$message.error('No sender email found');
        return;
      }
      const res = await (0, _leads.resolveFromEmail)(email);
      const {
        action,
        data
      } = res;
      if (action === 'CREATE_CLIENT') {
        this.$router.push({
          path: '/clients/add',
          query: {
            email: data.email,
            name: data.companyName,
            ...(data.companyId ? {
              companyId: String(data.companyId)
            } : {}),
            from: 'addToLead',
            step: 'client'
          }
        });
        return;
      }
      if (action === 'CREATE_CONTACT') {
        this.$router.push({
          path: '/clients-contacts/add',
          query: {
            email: data.email,
            clientId: String(data.clientId),
            from: 'addToLead',
            step: 'contact'
          }
        });
        return;
      }
      if (action === 'CREATE_LEAD') {
        const plainBody = row.body ? row.body.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : '';
        this.$router.push({
          path: '/leads/add',
          query: {
            clientId: String(data.clientId),
            contactId: String(data.contactId),
            email: data.email,
            emailId: String(row.id),
            subject: row.subject,
            emailBody: plainBody,
            source: 'email',
            accountEmail: row.accountEmail
          }
        });
        return;
      }
    } catch (e) {
      this.$message.error('Failed to process lead');
    }
  }
  async fetchData(id) {
    this.loading = true;
    const data = await (0, _email.getEmailById)(id);
    this.formData = data;
    this.loading = false;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: true
})], default_1.prototype, "isEdit", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'EmailDetails'
})], default_1);
var _default = exports.default = default_1;